import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-context-slider' })
export class ContextSliderComponent {
	slider: any;

	constructor(private element: HTMLElement) {
		let index = 0;

		if (location.hash) {
			index = +location.hash.substring(location.hash.length - 1);
			index = isNaN(index) ? 0 : index;
			setTimeout(() => {
				window.scrollTo(0, 0);
			}, 1);
		}

		this.slider = new Swiper(this.element, {
			init: false,
			speed: 400,
			autoHeight: true,
			allowTouchMove: false,
			initialSlide: 0,
			on: {
				init: () => {
					if (index > 0) {
						this.slider.once('slideChangeTransitionEnd', () => {
							setTimeout(() => {
								this.slider.updateAutoHeight(300);
							}, 500);
						});
						this.slider.slideTo(index, 0, true);
					}
				}
			}
		});

		const buttons = element.querySelectorAll('.js-context-slider-button');
		const backButtons = element.querySelectorAll('.js-context-slider-back');
		const slides = Array.from(element.querySelectorAll('.js-slide'));

		buttons.forEach(btn =>
			btn.addEventListener('click', e => {
				e.preventDefault();
				const index = slides.findIndex(s => s.getAttribute('id') === btn.getAttribute('href').substring(1));
				this.slider.slideTo(index);
			})
		);

		backButtons.forEach(btn =>
			btn.addEventListener('click', e => {
				this.slider.slideTo(0);
			})
		);

		this.element.addEventListener('update', () => this.slider.update())

		this.slider.init();
	}
}
